import { render } from "./SearchVin.vue?vue&type=template&id=64674805&scoped=true"
import script from "./SearchVin.vue?vue&type=script&lang=js"
export * from "./SearchVin.vue?vue&type=script&lang=js"

import "./SearchVin.vue?vue&type=style&index=0&id=64674805&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64674805"]])

export default __exports__